<div class="unit-member-pdf-options">
  <label class="form-check mb-2">
    <input class="form-check-input" type="radio" name="unitMemberPdfMode"
      [(ngModel)]="selectedMode" value="all">
    <span class="form-check-label">All sections</span>
  </label>

  <label class="form-check mb-2">
    <input class="form-check-input" type="radio" name="unitMemberPdfMode"
      [(ngModel)]="selectedMode" value="selected">
    <span class="form-check-label">Selected sections</span>
  </label>

  <div class="section-list" *ngIf="selectedMode === 'selected'">
    <label class="form-check mb-2" *ngFor="let section of sections">
      <input class="form-check-input" type="checkbox" [(ngModel)]="selected[section.Code]">
      <span class="form-check-label">
        {{ section.Display }}
        <small class="text-muted" *ngIf="!section.HasData">No information recorded</small>
      </span>
    </label>
    <div class="text-danger small" *ngIf="!hasSelection()">Select at least one section.</div>
  </div>
</div>
